// Shared navigation configuration for all navigation components
import { PRODUCTION_FRONTEND_URL } from '@/config/app';
export const navigationLinks = [
    {
        key: 'home',
        name: 'navigation.home.title',
        route: { name: 'shared.dashboard' },
        icon: 'solar:home-smile-linear',
        description: 'navigation.home.description',
        translate: true,
        roles: ['admin', 'exhibitor', 'buyer', 'speaker', 'sponsor', 'attendee']
    },
    {
        key: 'my-eshow',
        name: 'navigation.my-eshow.title',
        route: { name: 'shared.my-eshow' },
        icon: 'solar:monitor-smartphone-linear',
        description: 'navigation.my-eshow.description',
        translate: true,
        roles: ['admin', 'exhibitor', 'buyer', 'speaker', 'sponsor', 'attendee']
    },
    {
        key: 'companies',
        name: 'navigation.companies.title',
        route: { name: 'shared.companies' },
        icon: 'solar:buildings-2-linear',
        description: 'navigation.companies.description',
        translate: true,
        roles: [] //['admin', 'exhibitor', 'buyer']
    },
    {
        key: 'vib-buyers',
        name: 'navigation.vib-buyers.title',
        route: { name: 'shared.vib-buyers' },
        icon: 'solar:bag-smile-linear',
        description: 'navigation.vib-buyers.description',
        translate: true,
        roles: [] //['admin', 'buyer', 'exhibitor']
    },
    {
        key: 'community',
        name: 'navigation.community.title',
        route: { name: 'shared.community' },
        icon: 'solar:users-group-rounded-linear',
        description: 'navigation.community.description',
        translate: true,
        roles: ['admin', 'exhibitor', 'buyer', 'speaker', 'sponsor', 'attendee']
    },
    {
        key: 'speakers',
        name: 'navigation.speakers.title',
        route: { name: 'shared.speakers' },
        icon: 'solar:microphone-large-linear',
        description: 'navigation.speakers.description',
        translate: true,
        roles: ['admin', 'exhibitor', 'buyer', 'speaker', 'sponsor', 'attendee']
    },
    {
        key: 'agenda',
        name: 'navigation.agenda.title',
        route: { name: 'shared.agenda' },
        icon: 'solar:calendar-linear',
        description: 'navigation.agenda.description',
        translate: true,
        roles: ['admin', 'exhibitor', 'buyer', 'speaker', 'sponsor', 'attendee']
    },
    {
        key: 'products',
        name: 'navigation.products.title',
        route: { name: 'shared.products' },
        icon: 'solar:box-linear',
        description: 'navigation.products.description',
        translate: true,
        roles: [] //['admin', 'exhibitor', 'buyer']
    },
    {
        key: 'services',
        name: 'navigation.services.title',
        route: { name: 'shared.services' },
        icon: 'solar:settings-linear',
        description: 'navigation.services.description',
        translate: true,
        roles: [] //['admin', 'exhibitor', 'buyer']
    },
    {
        key: 'help-desk',
        name: 'navigation.help-desk.title',
        route: { name: 'shared.help-desk' },
        icon: 'solar:help-linear',
        description: 'navigation.help-desk.description',
        translate: true,
        roles: [] //['admin', 'exhibitor', 'buyer', 'speaker', 'sponsor', 'attendee']
    },
    {
        key: 'foodshow-on-demand',
        name: 'navigation.foodshow-on-demand.title',
        route: { name: 'shared.foodshow-on-demand' },
        icon: 'solar:clapperboard-play-linear',
        description: 'navigation.foodshow-on-demand.description',
        translate: true,
        roles: [] //['admin', 'exhibitor', 'buyer', 'speaker', 'sponsor', 'attendee']
    },
    {
        key: 'Programme',
        name: 'Programme Ifrane Forum 2025',
        route:  `${PRODUCTION_FRONTEND_URL}/PROGRAMME_IFRANE_FORUM_2025_1_.pdf`,
        icon: 'solar:calendar-linear',
        description: 'Programme Ifrane Forum 2025',
        translate: false,
        target: '_blank',
        roles: ['admin', 'exhibitor', 'buyer', 'speaker', 'sponsor', 'attendee']
    }
];

/**
 * Check if a route is an external URL
 * @param {string|object} route - The route (can be a string URL or route object)
 * @returns {boolean} True if route is an external URL
 */
export const isExternalLink = (route) => {
    return typeof route === 'string' && (route.startsWith('http://') || route.startsWith('https://'));
};

/**
 * Get the display name for a navigation link
 * @param {object} link - The navigation link object
 * @param {Function} t - Translation function (optional)
 * @returns {string} The display name
 */
export const getNavigationDisplayName = (link, t = null) => {
    if (link.translate !== false && t && typeof t === 'function') {
        return t(link.name);
    }
    return link.name;
};

/**
 * Get the target attribute for a navigation link
 * @param {object} link - The navigation link object
 * @returns {string|null} The target attribute value or null
 */
export const getNavigationTarget = (link) => {
    if (isExternalLink(link.route) && link.target === '_blank') {
        return '_blank';
    }
    return null;
};

/**
 * Filter navigation links based on user role
 * @param {string|null} userRole - The user's role
 * @returns {Array} Filtered navigation links
 */
export const getFilteredNavigationLinks = (userRole) => {
    if (!userRole) {
        // Default links for users without a role (basic navigation)
        const defaultKeys = ['home', 'my-eshow', 'community', 'help-desk'];
        return navigationLinks.filter(link => defaultKeys.includes(link.key));
    }

    const role = userRole.toLowerCase();
    return navigationLinks.filter(link => link.roles.includes(role));
};
